import React, { memo, forwardRef } from "react";
const SvgBeta = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M11 28.18a1 1 0 01-1-1V9.724c0-1.376.24-2.472.72-3.288.496-.832 1.16-1.432 1.992-1.8.832-.384 1.76-.576 2.784-.576 1.088 0 2.008.176 2.76.528.768.352 1.344.872 1.728 1.56.4.672.6 1.504.6 2.496 0 .768-.16 1.432-.48 1.992a3.944 3.944 0 01-1.224 1.344 4.851 4.851 0 01-1.704.696v.096c.816.112 1.536.36 2.16.744A3.998 3.998 0 0120.8 15.1c.368.656.552 1.472.552 2.448 0 1.088-.248 2.016-.744 2.784a4.614 4.614 0 01-1.992 1.752c-.832.384-1.776.576-2.832.576-.576 0-1.08-.032-1.512-.096a5.53 5.53 0 01-1.128-.288c-.336-.128-.68-.272-1.032-.432v5.336a1 1 0 01-1 1H11zm4.592-7.248c1.12 0 2.008-.304 2.664-.912.656-.624.984-1.496.984-2.616 0-.848-.168-1.544-.504-2.088a3.041 3.041 0 00-1.296-1.248 3.503 3.503 0 00-1.704-.432H14.56a.816.816 0 110-1.632h.936c.608 0 1.128-.136 1.56-.408a2.53 2.53 0 001.008-1.152c.24-.496.36-1.064.36-1.704 0-.992-.296-1.728-.888-2.208-.576-.48-1.272-.72-2.088-.72a3.97 3.97 0 00-1.608.336c-.512.208-.928.6-1.248 1.176-.32.576-.48 1.408-.48 2.496v10.128c.56.288 1.096.528 1.608.72.512.176 1.136.264 1.872.264z"
      />
    </svg>
  );
});
SvgBeta.displayName = "SvgBeta";
const MemoForwardRef = memo(SvgBeta);
export default MemoForwardRef;
